class ActionStrategy {
    private strategies: any[];

    /**
     * Принимает в себя массив стратегий
     * @param strategies
     */
    constructor(strategies: any[]) {
        this.strategies = strategies;
    }

    /**
     * Внутрь приходит объект, если shouldExecute возвращает true то выбирается соответствующая стратегия
     * @param object
     */
    selectStrategy(object) {
        const strategy = this.strategies.find(s => s.shouldExecute(object));
        if (!strategy) {
            throw new Error(`No suitable strategy found for object ${JSON.stringify(object)}`);
        }
        return strategy;
    }
}
export default ActionStrategy;